import __request__ from "routing/request";
export function loggers(requestOptions) {
  return __request__("GET", "/system/loggers", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function messages(limit = 1e3, requestOptions) {
  return __request__("GET", "/system/loggers/messages/recent", null, { "limit": limit }, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function subsystems(requestOptions) {
  return __request__("GET", "/system/loggers/subsystems", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setSubsystemLoggerLevel(subsystem, level, requestOptions) {
  return __request__("PUT", `/system/loggers/subsystems/${subsystem}/level/${level}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
export function setSingleLoggerLevel(loggerName, level, requestOptions) {
  return __request__("PUT", `/system/loggers/${loggerName}/level/${level}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
